<template>
  <filter-parent
    :title="texts.typeOfMeeting"
    :start-open="true"
    icon="meeting-type"
  >
    <div class="checkbox-wrapper column">
      <div
        v-for="meetingType in meetingTypeOptions"
        :key="meetingType.id"
        class="checkbox"
      >
        <input
          :id="`meeting-type-checkbox-${meetingType.id}`"
          v-model="meetingTypes"
          type="checkbox"
          :value="meetingType.id"
          autocomplete="off"
        />
        <label :for="`meeting-type-checkbox-${meetingType.id}`">{{
          meetingType.name
        }}</label>
      </div>
    </div>
  </filter-parent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FilterParent from '../common/FilterParent.vue';
import { MEETING_TYPE_KEYS, MEETING_TYPES } from 'Constants/meetingTypes';
export default defineComponent({
  name: 'TypeOfMeeting',

  components: { FilterParent },

  data() {
    return {
      texts: window.theme_vars.counselorGridTexts,
      meetingTypeOptions: [
        {
          id: MEETING_TYPE_KEYS.IN_PERSON,
          name: MEETING_TYPES.IN_PERSON,
        },
        {
          id: MEETING_TYPE_KEYS.VIDEO,
          name: MEETING_TYPES.VIDEO,
        },
        {
          id: MEETING_TYPE_KEYS.PHONE,
          name: MEETING_TYPES.PHONE,
        },
      ],
    };
  },

  computed: {
    meetingTypes: {
      get(): string[] {
        return this.$store.state.counselorGrid.filteredMeetingTypes;
      },
      set(value: string[]) {
        this.$store.commit('counselorGrid/setFilteredMeetingTypes', value);
      },
    },
  },
});
</script>
